import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_FILE_QUALITY_ACTION_TYPE } from '../actions/fileQualityScorecard.actions';

const initialState = null;

const fileQualityScorecardReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_FILE_QUALITY_ACTION_TYPE.SET_FILE_QUALITY_SCORECARD:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default fileQualityScorecardReducer;
